export enum Generations {
  ALL = 'All generations',
}
